import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { openPopup } from "../../store/popupSlice"
import Breadcrumb from "../../component/Breadcrumb";

const breadcrumbData = {
  newClass: "center-breadcrumb",
  list: [
    {
      page: "Home",
      slug: "/"
    },
    {
      page: "Shuttle Software",
      slug: ""
    },
  ]
}

export default function ShuttleHead({ featureId }) {
  const dispatch = useDispatch();
  return (
    <>
      <section className="shuttlepage-head header-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="shuttlehead-text">
                <h1>Enterprise Shuttle Booking & <br /> <span className="heading gradiant-color">Dispatch Software!</span></h1>

                <p>Manage booking, scheduling, routing, and fleet operations from one intelligent, white-label platform-built for workforce, campus, hospitality/airport, microtransit, and event shuttles.</p>
                <small>21 Days Free Trial | No Credit Card Required</small>
                <Breadcrumb breadcrumbData={breadcrumbData} />
                <Link style={{marginRight:"10px"}} onClick={() => dispatch(openPopup())} className="default-btn animated-btn">contact us</Link>

                <Link style={{marginLeft:"10px"}} to={`/features/${featureId}`} className="default-btn animated-btn">
                  Explore Features
                </Link>

                <img src="./assets/home/shuttle-mobile.webp" className="img-responsive" alt="Shuttle" />
                <div className="circle-waves">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
